//Environment Specific Config
let config = module.exports = {};
//
config.env  = 'production';
config.port = '3213';
config.host = 'https://stagingsecure.uplyftcapital.com:' + config.port;
//
//API URL
config.apiUrl = 'https://platform.uplyftcapital.com';

// Partner API URL
config.partnerApiUrl = 'https://api.uplyftcapital.com'